import { FA } from '@/components/common/icons/FA';
import { FEATURES } from '@/config/features';
import { getColor } from '@/helpers/utils';
import { CustomIconFC } from '@/types/shared';

export const WriterIcon: CustomIconFC = (props) => <FA icon={FEATURES.Writer.icon} theme="far" color={getColor('writer')} {...props} />;
